module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "button-social",
    class: _vm.buttonSocialDesignObject,
    attrs: {
      "page-url": _vm.page_url,
      "button-design": _vm.button_design,
      "title-social": _vm.title_social,
      "has-icon": _vm.has_icon,
      "has-square-edges": _vm.has_square_edges
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showShareWindow.apply(null, arguments)
      }
    }
  }, [(this.has_icon) ? _c('i', {
    staticClass: "icon-line"
  }) : _vm._e(), _vm._v(" "), (this.title_social) ? _c('span', {
    staticClass: "title-social"
  }, [_vm._v(_vm._s(_vm.title_social))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08a43914","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShareLineButton.vue
// module id = 1107
// module chunks = 0